import { Button } from "antd"
import Popup from "components/molecules/Popup/Popup"
interface confirmDeleteProps {
  onDelete: () => void;
  onCancel: () => void;
}
export const ConfirmDelete = (props: confirmDeleteProps) => {
  const { onCancel, onDelete } = props
  return (
    <Popup type="modal" onClose={() => { }} >
      <div className="flex items-center justify-center z-50">
        <div className="p-6 rounded-lg">
          <h2 className="text-lg font-bold mb-4">Confirm Deletion</h2>
          <p className="mb-4">Are you sure you want to delete this page URL?</p>
          <div className="flex justify-end">
            <Button className="bg-red-500 text-white-500 px-4 py-2 rounded mr-2" onClick={onDelete}>
              Yes
            </Button>
            <Button className="bg-gray-400 text-white-500 px-4 py-2 rounded" onClick={onCancel}>
              No
            </Button>
          </div>
        </div>
      </div>
    </Popup>
  )
}